import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  getUserMe,
  getSentryEnhancedDiagnosticsSetting,
  getSentryExtendedTrackingSetting,
} from '../apps/main/rootReducer';
import { initializeSentry, isSentryReady } from '../services/sentryService';
import * as ConfigValues from '../util/configValues';

export const useSentryInitialization = () => {
  const userMe = useSelector(getUserMe);
  const extendedTrackingSettings = useSelector(
    getSentryExtendedTrackingSetting
  );
  const isEnhancedDiagnosticsEnabled = useSelector(
    getSentryEnhancedDiagnosticsSetting
  );

  const hasInitialized = useRef(false);

  const { isEnabled, replayEnabled, userIdTracing } = extendedTrackingSettings;
  const userId = userMe?.id;

  useEffect(() => {
    if (hasInitialized.current || isSentryReady()) {
      return;
    }

    if (
      userId &&
      !ConfigValues.REACT_APP_API_REDIRECT_URL.includes('prio.local')
    ) {
      console.log(
        '[useSentryInitialization] Initializing Sentry with settings:',
        {
          isEnabled,
          replayEnabled,
          userIdTracing,
          isEnhancedDiagnosticsEnabled,
          userId,
        }
      );

      const config = {
        isExtendedTrackingEnabled:
          isEnabled || ConfigValues.REACT_APP_SENTRY_EXTENDED_TRACKING,
        replayEnabled:
          replayEnabled || ConfigValues.REACT_APP_SENTRY_EXTENDED_TRACKING,
        userIdTracing:
          userIdTracing || ConfigValues.REACT_APP_SENTRY_EXTENDED_TRACKING,
        isEnhancedDiagnosticsEnabled,
        userId: userIdTracing ? userId : undefined,
      };

      initializeSentry(config);
      hasInitialized.current = true;
    }
  }, [
    userId,
    isEnabled,
    replayEnabled,
    userIdTracing,
    isEnhancedDiagnosticsEnabled,
  ]);
};
